export default "__VITE_ASSET__BmOevIXf__"